export enum LoadingStatusEnum {
	NotLoaded = "not loaded",
	Loading = "loading",
	Loaded = "loaded",
	Error = "error",
}
